import { render, staticRenderFns } from "./StoreDetailSidebar.vue?vue&type=template&id=68854da0&scoped=true"
import script from "./StoreDetailSidebar.vue?vue&type=script&lang=js"
export * from "./StoreDetailSidebar.vue?vue&type=script&lang=js"
import style0 from "./StoreDetailSidebar.vue?vue&type=style&index=0&id=68854da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68854da0",
  null
  
)

export default component.exports